var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud_Upload",
    "data-name": "Cloud Upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 9.866a10 10 0 0 0 -19.8-1.866h-.2a8 8 0 0 0 0 16h6a1 1 0 0 0 0-2h-6a6 6 0 1 1 .9-11.925 1 1 0 0 0 1.145-.887 8 8 0 0 1 15.955.812c0 .093-.007.184-.013.275l-.01.162a1 1 0 0 0 .617.978 5.5 5.5 0 0 1 -2.094 10.585h-2.5a1 1 0 0 0 0 2h2.5a7.5 7.5 0 0 0 3.5-14.134z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.293 16.707a1 1 0 0 0 1.414-1.414l-5-5a.99.99 0 0 0 -.326-.217 1 1 0 0 0 -.764 0 .99.99 0 0 0 -.326.217l-5 5a1 1 0 0 0 1.414 1.414l3.295-3.293v17.586a1 1 0 0 0 2 0v-17.586z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon1);
export default __webpack_public_path__ + "static/media/upload-icon-1.f35abae88031ad63cdbf886d8fdd24fe.svg";
export { ForwardRef as ReactComponent };